$('#blogs-btn').on('click', function () {
  $('.hidden-boxes-wrapper').slideToggle('fast');
  let hide = $(this).data('hide');
  let show = $(this).data('show');
  $(this).text($(this).text() == hide ? show : hide);
});
